import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// App
import { ListResult } from '../api/core/list-result';
import { Note } from '../api/data-model';

// App Config
import { BACKEND_URL } from '../app.config';

@Injectable()
export class NoteService {
  constructor(private readonly http: HttpClient, @Inject(BACKEND_URL) private readonly baseUrl: string) {}

  getNotes(entityId: string, entityType: number, sorting: string, skipCount: number, maxResultCount: number): Observable<ListResult<Note>> {
    return this.http.get<ListResult<Note>>(this.baseUrl + '/api/app/note', {
      params: {
        entityId,
        entityType,
        sorting,
        skipCount,
        maxResultCount,
      },
    });
  }

  addNote(note: Partial<Note>): Observable<Note> {
    return this.http.post<Note>(this.baseUrl + '/api/app/note', note);
  }

  updateNote(note: Note): Observable<Note> {
    return this.http.put<Note>(`${this.baseUrl}/api/app/note/${note.id}`, note);
  }

  deleteNote(noteId: string): Observable<void> {
    return this.http.delete<void>(this.baseUrl + '/api/app/note/' + noteId);
  }
}
